import { useRouter } from 'next/router';
import { memo } from 'react';
import tw, { styled } from 'twin.macro';
import { useTranslation } from 'next-i18next';

import { JobPositionExplorer } from '@restworld/ui-ds';
import { getAssetSrc } from '@restworld/utils-common';
import { useAuth } from '@restworld/feature-authentication';

import { useStaticImage } from '../../context/static-images';

export const SeasonalJobPositions = memo(() => {
  const router = useRouter();
  const seasonalImg = useStaticImage('seasonal', getAssetSrc('/utils-assets/beach.png'));
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation('home-page');
  return (
    <Container noPaddingBottom={isAuthenticated}>
      <JobPositionExplorer
        header={t('famous_tourist_destination')}
        subheader={t('experience_the_thrill')}
        hasButton
        buttonIcon="UmbrellaIcon"
        buttonText={t('discover_seasonal_jobs')}
        previewImage={seasonalImg}
        onSubmit={() => router.push('/cerco-lavoro/stagionale')}
      />
    </Container>
  );
});

export const Container = styled.div<{ noPaddingBottom: boolean }>(({ noPaddingBottom }) => [
  tw`flex w-full flex-col lg:pt-15 lg:pb-28  pt-0 pb-0`,
  noPaddingBottom && tw`lg:pb-0`,
]);
